import { Outlet } from 'react-router-dom';

import './DeviceVerification.scss';

const DeviceVerification = () => {
	return (
		<div className='DeviceVerification'>
			<Outlet />
		</div>
	);
};

export default DeviceVerification;
